import { createIDTagging, useIDTagging, useTranslation } from '@msdk/common'
import { Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@msdk/ui'
import React from 'react'

import { FieldEntityPair } from '../field-entity-pair'
import { NodeItem } from '../node'

interface Props {
  item: NodeItem
  selected: FieldEntityPair[]
  onToggle: (item: FieldEntityPair) => void
}

export function Item({ item, selected, onToggle }: Props) {
  const idTaggingEnabled = useIDTagging()
  const t = useTranslation()
  const description = idTaggingEnabled
    ? createIDTagging(item.microservice, item.entityName, item.idml)
    : t(item.idml, item.tDescription ?? item.description)
  const isChecked = () => {
    return !!selected.find((i) => i.entityName === item.entityName && i.fieldName === item.value)
  }

  return (
    <ListItem key={item.value}>
      <ListItemButton dense onClick={() => onToggle(item.toFieldEntityPair())}>
        <ListItemIcon>
          <Checkbox edge="start" checked={isChecked()} tabIndex={-1} disableRipple />
        </ListItemIcon>
        <ListItemText primary={description} />
      </ListItemButton>
    </ListItem>
  )
}
